window.assetForm = cafm.assets.form = {

    asset: null,
    loadAsset: function (asset, moduleType) {
        var targetUrlSegment = moduleType === 0 ? "editasset" : "editassetam";
        cafm.views.main({
            url: cafm.url.get(`Assets/${targetUrlSegment}/${asset.ID}`),
            viewModel: asset,
            viewModelTarget: '#' + cafm.res.consts.ElementId_MainForm,
            isForm: true,
            onInit: function () {

                cafm.actions.setObjectInContextId(asset.ID);
                if (isMobile)
                    $('<a id="backBtn" class="headButton"></a>').appendTo('#header-container').show();
            },
            onLoad: function () {

                cafm.forms.placeMainFormToolbar();
                cafm.forms.setMainFormLoadedKeys([cafm.res.consts.DataKey_AssetMainDetails, cafm.res.consts.DataKey_AssetExtendedDetails]);
                cafm.forms.showFormSection(0, true);

                assetForm.setAsset(cafm.views.getMainFormViewModel(), false);

                // add the asset to the client history
                nav.addToHistory({
                    itemKey: asset.ID,
                    itemTitle: asset.Description,
                    itemType: cafm.assets.form.helpers.getHistoryItemType(asset),
                    navUrl: document.location.pathname
                });

                cafm.handlers.set('cafm.forms.afterFormTabChanged', function (contentElement) {

                    // setup toolbar
                    $('.cTb', contentElement).setupToolbar();

                    // check for removable items
                    cafm.forms.checkForRemovables();
                });

                // format barcode link
                let barcodeElement = $(".cfRoValSpan[name=\"Barcode\"]");
                cafm.scanner.formatBarcodeLink(barcodeElement);
            }
        });
    },
    setAsset: function (asset, bindViewModel) {

        assetForm.asset = asset;

        if (bindViewModel === true) {

            cafm.views.bindMainFormViewModel(asset);
        }
    },
    onAssetsTreeSelect: function (e) {

        switch (e.type) {

            case cafm.enums.TreeViewItemType.FormCategory:

                forms.switchFormPanel(e);
                break;

            case cafm.enums.TreeViewItemType.FormAction:

                assetForm.performFormAction(e);
                break;
        }
    },
    performFormAction: function (e) {

        var key = e.key;
        var actionEnum = isStr(key) ? cafm.enums.AssetFeature[key] : key;

        switch (actionEnum) {

            case cafm.enums.AssetFeature.AddNote:

                cafm.views.openChildActionWindow(e);
                break;

            case cafm.enums.AssetFeature.AddMeterReading:

                assetForm.meterReadingHandlers.addreading(e);
                break;

            case cafm.enums.AssetFeature.RemoveSelected:

                var listWrappers = $('.k-content.k-state-active .cLvWrap', cafm.views.getMainFormWidget());

                listWrappers.each(function (i, el) {

                    var selected = $(el).getListSelectedDataItems();

                    if (selected && selected.length) {

                        $('.cTb [data-key="Remove"]', el).click();
                    }
                });
                break;
        }
    },
    childActionPerformed: function (asset) {

        if (!isNullOrUndefined(asset)) {

            assetForm.setAsset(asset, true);
        }
    },
    meterReadingHandlers: {

        onMetersDataBound: function (e) {

            $('.meterReadingsLink', e.sender.element).each(function (i, link) {

                var link = $(link);
                var mrPlc = link.parent().find('.meterReadingsPlc');

                link.attr('data-target', mrPlc.attr('id'));
                link.addClass('elementState')
                    .data('collapsestatechanged', assetForm.meterReadingHandlers.requestMeterReadings)
                    .setupElementState();
            });

            var currentAssetId;
            $('> li', e.sender.element).each(function (i, el) {

                var listItem = $(el).getListItemParent(), meter = listItem.getListViewDataItem(listItem.data('id'));

                // add asset groups if on work order page
                if (cafm.hd.workOrder && currentAssetId != meter.AssetID) {

                    $('<li class="cLvIt"><h2 class="list-group-header">{0}</h2></li>'.format(cafm.util.encodeHtml(cafm.res.str.TemplateMetersFor0.format(meter.AssetDescription)))).insertBefore(listItem);
                    currentAssetId = meter.AssetID;
                }

                // check for a valid permission to add meter readings
                if (cafm.util.getReference('workOrder.Security.Actions.AddMeterReading', cafm.hd) !== true && cafm.util.getReference('asset.CanAddMeterReadings', cafm.assets.form) !== true) {

                    $('> .addMeterReading', listItem).remove();
                }
            });

            // ensure the cached work order contains any newly created meter readings..
            if (cafm.util.getReference('workOrder.IsCacheable', cafm.hd) === true && !cafm.isOffline()) {

                cafm.hd.workOrder.AssetMeters = e.sender.dataSource.data();

                // refresh cached wo
                cafm.hd.workOrderCachingHandler.cacheWorkOrderInContext(false);
            }
        },
        requestMeterReadings: function (link, visible) {

            var mrPlc = link.parent().find('.meterReadingsPlc:first');

            if (mrPlc.children().length === 0) {

                var listItem = link.getListItemParent(), meter;

                if (listItem.length) {

                    meter = listItem.getListViewDataItem(listItem.data('id'));
                }
                else {

                    var tabs = $('#meter-tabs').getKendoTabStrip(), index = tabs ? tabs.select().index() : 0;
                    meter = cafm.views.getActionForm().data('allMeters')[index];
                }

                var buildReadingsGrid = function (r) {

                    if (cafm.util.hasItem(r)) {

                        mrPlc.kendoGrid({
                            dataSource: {
                                data: r,
                                schema: {
                                    model: {
                                        fields: {
                                            ReadingDateTime: { type: 'string' },
                                            Value: { type: 'number' },
                                            ReadingCreatedBy: { type: 'string' }
                                        }
                                    }
                                },
                                pageSize: 10,
                                sort: {
                                    field: 'ReadingDateTime',
                                    dir: 'desc'
                                }
                            },
                            sortable: true,
                            pageable: true,
                            scrollable: false,
                            columns: [
                                {
                                    field: 'ReadingDateTime',
                                    title: cafm.res.str.LabelReadingDateTime,
                                    format: '{0:g}',
                                    width: '33%',
                                    template: function (mr)
                                    {
                                        return kendo.htmlEncode(cafm.util.toFormattedDateTime(mr.ReadingDateTime));
                                    }
                                },
                                { field: 'Value', title: cafm.res.str.LabelReadingValue, width: '34%', template: '#: ValueFormatted #' },
                                { field: 'ReadingCreatedBy', title: cafm.res.str.LabelCreatedBy, width: '33%' }
                            ],
                            dataBound: function (e) {

                                cafm.util.modifyPager(e.sender.wrapper, e.sender.dataSource);

                                // ensure the readings are kept in view
                                e.sender.wrapper.scrollToElement();
                            }
                        });
                    }
                    else {

                        mrPlc.append($('<span class="noReadings">{0}</span>'.format(cafm.res.str.TextNoItems)));
                    }
                }

                if (cafm.isOffline()) {

                    buildReadingsGrid(meter.Readings);
                }
                else {

                    cafm.actions.execute({

                        url: cafm.url.api('Asset/GetMeterReadings'),
                        values: cafm.util.createParentChildId(meter.AssetID, meter.ID),
                        loaderTarget: mrPlc[0],
                        statusCodeFuncs: {

                            200: function (r, s, m, a) {

                                buildReadingsGrid(r.Items);
                            }
                        },
                        fallack: function () {

                            buildReadingsGrid(meter.Readings);
                        }
                    });
                }
            }
        },
        addreading: function (e) {

            var button = $(e.currentTarget), meterId = button.data('id'), title = button.text(), assetItemId;

            if (button.hasClass('asset-item-menu-btn')) {
                assetItemId = button.closest('.asset-item').data('id');
                var allMeters = cafm.util.whereByFieldValue(cafm.hd.workOrder.AssetMeters, 'AssetID', assetItemId);
                if (!cafm.util.hasItem(allMeters)) {
                    e.stopPropagation();
                    return false;
                }
            }

            if (assetItemId) {

                let asset = cafm.assets.getWorkOrderAsset(assetItemId);
                title = button.find('.asset-item-text').text();

                let siteLogo = $('#site-logo'),
                    siteLogoText = siteLogo.html();

                if (isMobile) {
                    cafm.resetSiteLogoText = () => {
                        siteLogo.html(siteLogoText);
                    }
                    siteLogo.text(asset.Description);
                }
            }

            e = {
                action: 'Assets/NewMeterReading',
                title: title,
                height: cafm.views.actionWindowConfig.mediumLarge.height(),
                onInit() {
                    cafm.views.getActionForm().addClass('meter-readings');
                },
                onLoad(panel) {
                    assetForm.meterReadingHandlers.onFormLoad(panel, button.data('id'), assetItemId);
                },
                beforeSend: function (request) {
                    request.setRequestHeader('Cafm-ChildID', assetItemId);
                }
            };

            cafm.views.openChildActionWindow(e);
        },
        updateAllMetersReadingsInCache: function (assetItemId) {
            var allMeters = cafm.util.whereByFieldValue(cafm.hd.workOrder.AssetMeters, 'AssetID', assetItemId);
            var viewModel = cafm.views.getActionWindowViewModel();
            if (isDefined(viewModel)) {
                var submittedMeterId = isDefined(viewModel.get('AssetMeterId')) ? viewModel.get('AssetMeterId') : '';
                
                for (var i = 0, l = allMeters.length; i < l; i++) {
                    //Skip the meter already in the view model
                    //as well as meter with no value
                    if ((allMeters[i].ID != submittedMeterId)
                        && (isDefined(allMeters[i].ReadingValue))) {
                        var meter = allMeters[i];
                        var eachSaveMeterData ={
                            LatestReadingDateTime: cafm.web.funcs.fromUTCToSessionDateTime(meter.LatestReadingDateTime),
                            LatestReadingValue: meter.LatestReadingValueFormatted,
                            Value: isDefined(meter.ReadingValue) ? meter.ReadingValue : 0,
                            ReadingDateTime: isDefined(meter.ReadingDateTime) ? meter.ReadingDateTime : cafm.web.funcs.getNowUTC(),
                            AssetMeterId: meter.ID,
                            AssetId: meter.AssetID,
                            WorkOrderID: cafm.hd.workOrder.ID,
                            ConfirmationPrompt: null,
                            DataCaptureRequest: null
                        };

                        //Reset the cache value
                        allMeters[i].LatestReadingDateTime = eachSaveMeterData.ReadingDateTime;
                        allMeters[i].LatestReadingValueFormatted = allMeters[i].ReadingValueFormatted;
                        allMeters[i].ReadingValue = 0;
                        allMeters[i].ReadingDateTime = cafm.web.funcs.getNowUTC();
                        if (!allMeters[i].Readings) allMeters[i].Readings = [];
                        allMeters[i].Readings.unshift(eachSaveMeterData);

                        cafm.actions.execute({
                            elementId: "update-each-meter-reading",
                            url: cafm.url.api(`asset/SaveMeterReading`),
                            method: 'POST',
                            values: eachSaveMeterData,
                            preventValidationMessage: true,
                            offlineActionType: cafm.enums.OfflineActionType.AddMeterReading,
                            sync: true,
                            onInvalid() {
                            },
                            success(res) {
                            }
                        });
                    }
                    
                }
                cafm.views.getActionForm().data('allMeters', allMeters);
            }
        },
        onFormLoad: function (panel, meterId, assetItemId) {

            var viewModel = cafm.views.getActionWindowViewModel(),
                hasId, meter, assetMeters, allMeters, meterIndex;

            if (assetItemId) {

                allMeters = cafm.util.whereByFieldValue(cafm.hd.workOrder.AssetMeters, 'AssetID', assetItemId);
                if (cafm.util.hasItem(allMeters)) meterId = allMeters[0].ID;

                if (!cafm.hd.workOrder.Security.Actions.AddMeterReading) {

                    panel.find('#new-reading').hide();
                }
                else {

                    viewModel.WorkOrderID = cafm.hd.workOrder.ID;
                }
            }
            else {

                allMeters = $('#assetMetersLv').getDataSource().data();
                if (meterId) {

                    meter = cafm.util.findByFieldValue(allMeters, 'ID', meterId);
                    meterIndex = cafm.util.indexOf(allMeters, function (m) { return m.ID == meterId });
                }
            }

            hasId = cafm.util.guidHasValue(meterId);

            var fieldset = panel.find('.actionFieldSet');
            var mrPlc = $('<div id="{0}" class="meterReadingsPlc"></div>'.format(cafm.guid.newGuid())).insertAfter(fieldset);
            var meterReadingsLink = $('<a class="cLink meterReadingsLink">{0}</a>'.format(cafm.res.str.LabelReadingHistory)).insertAfter(fieldset);

            var mrPlc = meterReadingsLink.parent().find('.meterReadingsPlc');
            meterReadingsLink.attr('data-target', mrPlc.attr('id'));
            meterReadingsLink.addClass('elementState')
                .data('collapsestatechanged', assetForm.meterReadingHandlers.requestMeterReadings)
                .setupElementState();

            var displayMeter = function (e) {

                //Check any value first and gives warning
                if (isDefined(e)) {
                    var currentIndex = e.sender.select().index();
                    if (isDefined(allMeters[currentIndex])) {
                        allMeters[currentIndex].ReadingValue = viewModel.get('Value');
                        allMeters[currentIndex].ReadingValueFormatted = viewModel._valueFormatted;
                        //if (allMeters[currentIndex].ReadingDateTime != viewModel.get('ReadingDateTime'))
                        //    allMeters[currentIndex].ReadingDateTime = cafm.web.funcs.fromSessionToUTCDateTime(viewModel.get('ReadingDateTime'));
                        allMeters[currentIndex].ReadingDateTime = viewModel.get('ReadingDateTime');
                    }
                    dodisplayMeter(e);
                }
            }

            var dodisplayMeter = function (e) {
                cafm.util.callFunctionAsync({
                    func: function () {
                        var meter = allMeters[isDefined(e) ? e.sender.select().index() : 0];
                        viewModel.set({
                            LatestReadingDateTime: cafm.web.funcs.fromUTCToSessionDateTime(meter.LatestReadingDateTime),
                            LatestReadingValue: meter.LatestReadingValueFormatted
                        });
                        setMd(meter.ID);
                        mrPlc.hide().children().remove();
                        meterReadingsLink.removeAttr('data-expanded');

                        var latestValEl = fieldset.find('#LatestReadingValue');
                        latestValEl.addClass('reading');
                        latestValEl.parent().find('.unitOfMeasure').remove();
                        $('<span class="unitOfMeasure">{0}</span>'.format(meter.MeasureDefinition.Description)).insertAfter(latestValEl);
                    }, timeout: 10
                });
            }

            if (allMeters && allMeters.length == 1) {

                fieldset.prepend('<header>{0}</header>'.format(allMeters[0].Description));
                displayMeter();
            }
            else {

                $('<div id="meter-tabs" class="cafmTabs"></div>').kendoTabStrip({
                    dataTextField: "Description",
                    dataSource: allMeters,
                    select: function (e) {
                        displayMeter(e);
                    }
                }).insertBefore(fieldset).getKendoTabStrip().select(isDefined(meterIndex) && meterIndex > -1 ? meterIndex : 0);
            }

            cafm.views.getActionForm().data('allMeters', allMeters);

            if (hasId) {
                meter = cafm.util.findByFieldValue(allMeters, 'ID', meterId);
                assetMeters = cafm.util.whereByFieldValue(allMeters, 'AssetID', meter.AssetID);
            }

            var setMd = function (meterId) {

                $('#Value', panel).enableNumeric(false);

                if (cafm.util.guidHasValue(meterId)) {

                    meter = cafm.util.findByFieldValue(allMeters, 'ID', meterId);
                    if (!meter) return;

                    var md = meter.MeasureDefinition,
                        actionForm = cafm.views.getActionForm(),
                        viewModel = actionForm.getViewModel(),
                        valueTbox = $('#Value', panel),
                        ktb = valueTbox.getKendoNumericTextBox(),
                        format = '',
                        formatDig = md.DisplayLeadingZeros ? '0' : '#',
                        max;

                    viewModel.set('Value', isDefined(meter.ReadingValue) ? meter.ReadingValue : 0);
                    viewModel.set('ReadingDateTime', isDefined(meter.ReadingDateTime) ? meter.ReadingDateTime : cafm.web.funcs.getNowUTC());
                    viewModel.set('AssetMeterId', meterId);
                    viewModel.set('AssetId', meter.AssetID);

                    if (md.NumberOfIntegers) {

                        if (md.DisplayLeadingZeros) {

                            for (var i = md.NumberOfIntegers; i > 0; i--) {

                                if (md.DisplayThousandsSeparator && i % 3 === 0) format += ','
                                format += formatDig;
                            }
                        }
                        else {

                            format = formatDig;
                        }

                        if (md.NumberOfDecimals) {

                            format += '.';
                            for (var i = 0; i < md.NumberOfDecimals; i++) {

                                format += '0'
                            }
                        }

                        ktb.setOptions({
                            decimals: md.NumberOfDecimals,
                            format: format
                        });

                        ktb.element.off('focus.cafm').on('focus.cafm', function (e) {

                            if (this.value == 0) this.value = '';
                        });

                        ktb.element.off('blur.cafm').on('blur.cafm', function (e) {

                            var element = $(e.currentTarget);
                            element.getParentViewModel()._valueFormatted = element.getKendoNumericTextBox().wrapper.find('.k-formatted-value').val();
                        });

                        // custom validation of input of integers and decimals
                        ktb.element.off('input.cafm').on('input.cafm', function (e) {

                            var v = this.value, ind, decs, isMinus;
                            if (v && (ind = v.indexOf('.')) > -1) {

                                decs = v.substring(ind);
                                v = v.substring(0, ind);
                            }
                            if (v && (ind = v.indexOf('-')) == 0) {

                                v = v.substring(1);
                                isMinus = true;
                            }
                            if (v.length > md.NumberOfIntegers) {

                                var pos = this.selectionStart;
                                v = (isMinus ? '-' : '') + v.substring(0, v.length - 1) + (decs || '');
                                this.value = v;
                                this.selectionStart = pos;
                                this.selectionEnd = pos;
                            }
                            else if (md.NumberOfDecimals && decs && (decs.length - 1) > md.NumberOfDecimals) {

                                var pos = this.selectionStart;
                                v = (isMinus ? '-' : '') + (v || '') + decs.substring(0, decs.length - 1);
                                this.value = v;
                                this.selectionStart = pos;
                                this.selectionEnd = pos;
                            }
                        });
                    }

                    valueTbox.trigger('blur').enableNumeric(true);

                    if (md.UnitOfMeasureCodeDescription) {

                        var lbl = valueTbox.closest('.cfField').find('.cfLabel');
                        var unitLbl = lbl.find('.unitDesc');

                        if (!unitLbl.length) {

                            lbl.append($('<span/>', {
                                'class': 'unitDesc'
                            }));
                            unitLbl = lbl.find('.unitDesc');
                        }

                        unitLbl.text(' ({0})'.format(md.UnitOfMeasureCodeDescription));
                    }

                    if (isNum(md.ReadingRangeMin)) {

                        actionForm.data('minValue', md.ReadingRangeMin);
                    }

                    if (md.ReadingRangeMax) {

                        actionForm.data('maxValue', md.ReadingRangeMax);
                    }
                }
            }

            if (!hasId)
                $('#Value', panel).enableNumeric(false);
            else {
                setMd(meterId);
            }
        },
        validate: function () {
            /// <summary>Meter reading validation function</summary>

            var actionForm = cafm.views.getActionForm();

            if (actionForm.data('continueAnyway')) {

                valid = true;
            }
            else {

                var min = actionForm.data('minValue');
                var max = actionForm.data('maxValue');
                var vm = this.get('values');
                var valid;

                if (isNum(min) && vm.Value < min) {

                    valid = false;
                }
                else if (isNum(max) && vm.Value > max) {

                    valid = false;
                }
                else {

                    valid = true;
                }
            }

            this.set('valid', valid);

            if (!valid) {

                if (!min) {

                    min = 0;
                }

                if (!max) {

                    max = 0;
                }

                var msg = cafm.res.str.TemplateOutsideExpectedRangeWarning.format(vm.Value, min, max);

                this.set('validationMessage', msg);

                var action = this, nl = cafm.getClientSettings().newLine;

                cafm.util.yesNoDialogue({
                    message: '{0}{1}{2}{3}'.format(msg, nl, nl, cafm.res.str.TextContinueAnyway),
                    messageType: cafm.enums.MessageType.Warning,
                    yesHandler: function () {

                        actionForm.data('continueAnyway', true);

                        setTimeout(function () {

                            action.execute();
                        }, 500);
                    }
                });
            }
        },
        beforeSend: function (response, message, action) {


        },
        success: function (response, action) {
            if (cafm.nav.isNav(cafm.enums.Navigatable.AssetsEditAsset)) {

                assetForm.childActionPerformed(response);
                $('#' + cafm.res.consts.ElementId_AssetMetersListView).refreshListDS();
                cafm.views.closeActionWindow();
            }
            else if (cafm.hd.workOrder) {

                var viewModel = cafm.views.getActionWindowViewModel().toJSON(),
                    meter = cafm.util.findByFieldValue(cafm.hd.workOrder.AssetMeters, 'ID', viewModel.AssetMeterId),
                    asset = cafm.assets.getWorkOrderAsset(viewModel.AssetId);

                if (asset) {
                    asset.MeterReadingAdded = true;
                }

                if (meter) {
                    meter.LatestReadingDateTime = viewModel.ReadingDateTime;
                    meter.LatestReadingValueFormatted = viewModel._valueFormatted;
                    viewModel.ValueFormatted = viewModel._valueFormatted;
                    viewModel.ReadingCreatedBy = cafm.auth.personName();

                    if (!meter.Readings) meter.Readings = [];
                    meter.Readings.unshift(viewModel);

                    //Now deal with the rest of meters, if any
                    assetForm.meterReadingHandlers.updateAllMetersReadingsInCache(viewModel.AssetId);

                    // refresh, close form, focus the asset
                    cafm.assets.refreshList();
                    cafm.views.closeActionWindow();
                    cafm.assets.showAssetInList(viewModel.AssetId);
                }
            }

        },
        offlineActionType: function () { return cafm.enums.OfflineActionType.AddMeterReading; },
        fallback: function () {

            if (cafm.hd.workOrder) {

                var viewModel = cafm.views.getActionWindowViewModel().toJSON(),
                    meter = cafm.util.findByFieldValue(cafm.hd.workOrder.AssetMeters, 'ID', viewModel.AssetMeterId),
                    asset = cafm.assets.getWorkOrderAsset(viewModel.AssetId);

                if (asset) {
                    asset.MeterReadingAdded = true;
                }

                if (meter) {

                    meter.LatestReadingDateTime = viewModel.ReadingDateTime;
                    meter.LatestReadingValueFormatted = viewModel._valueFormatted;
                    viewModel.ValueFormatted = viewModel._valueFormatted;
                    viewModel.ReadingCreatedBy = cafm.auth.personName();

                    if (!meter.Readings) meter.Readings = [];
                    meter.Readings.unshift(viewModel);

                    //Now deal with the rest of meters, if any
                    assetForm.meterReadingHandlers.updateAllMetersReadingsInCache(viewModel.AssetId);

                    // end the offline action (caches work order)
                    hdActions.helpers.endOfflineAction({
                        cacheWorkOrder: true,
                        preventCloseWindow: true
                    });

                    // refresh, close form, focus the asset
                    cafm.assets.refreshList();
                    cafm.views.closeActionWindow();
                    cafm.assets.showAssetInList(viewModel.AssetId);
                }
            }
        }
    },
    handlers: {
        logWorkOrder: function () {

            var asset = cafm.views.getMainFormViewModel();
            cafm.hd.nav.logWorkOrderForAsset(asset.ID);
        },
        onWorkOrdersRetrieved: function (args) {

            cafm.hd.onWoInfoDataRetrieved(args);
        },
        onWorkOrderDataBound: function (args) {

            $('.cLvIt', args.sender.element).each(function (i, item) {

                var lcsStatus = $('.lcsStatus', item);
                var lcs = lcsStatus.data('value');
                lcsStatus.replaceWith($(cafm.hd.formatLcs(lcs)));
            });
        }
    },
    helpers: {

        getHistoryItemType: function (asset) {

            return cafm.enums.HistoryItemType[cafm.enums.getEnumKey(cafm.enums.AssetType, asset.AssetType) + 'Asset'];
        },
        getWorkOrderLink: function (workOrder) {

            if (isNullOrUndefined(workOrder.VirtualKey)) {

                return cafm.url.get(cafm.res.consts.Url_HelpdeskWorkOrderByRef.format(workOrder.Reference));
            }
            else {

                var asset = cafm.views.getMainFormViewModel();
                return cafm.hd.nav.virtualWorkOrderForAssetPath(asset.ID, workOrder.VirtualKey);
            }
        }
    }
}